import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, RouterStateSnapshot } from '@angular/router';

import 'rxjs/add/operator/map';

import { AuthService } from '../../Auth/auth.service';
import { UserService } from '../../User/user.service';

@Injectable()
export class AuthGuard implements CanActivate {
  isLoggedIn: Boolean = false;
  constructor(private auth: AuthService, private userService: UserService, private router: Router) {
    this.isLoggedIn = this.userService.isLoggedIn();
  }

  canActivate(route, state: RouterStateSnapshot) {
    if (this.userService.isLoggedIn()) {
      return true;
    } else {
      this.router.navigateByUrl('/welcome');
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/Guards/Auth-Guard/auth-guard.service.ts